import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_Province = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const Province_Onchange = (event) => {

        var index = event.nativeEvent.target.selectedIndex;
        props.onChange(event.target.value, event.nativeEvent.target[index].text)
    }
    useImperativeHandle(ref, () => ({
        BindProvince(Id) {
            var Config = {
                headers: {
                    'Content-Type': 'application/json',
                    'ApiKey': General.APIKey(),
                    'IsDeleted': 0,

                },
                url: General.ApiRoute() + "/ProvinceCity/GetProvince",
                method: 'Get',
                withCredentials: true,
            }
            trackPromise(
                axios(Config)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                Id: result.data[i].id,
                                Title: result.data[i].title,
                            })

                            if (result.data[i].id == Id) {
                                props.onChange(Id, result.data[i].title)
                            }
                        }
                        setList(tmp)
                    }) 
            )
        }
    }))



    return (
        <>
            <select className={props.className} onChange={Province_Onchange} value={props.value}>
                <option value="-1">انتخاب نمایید</option>
                {
                    List.map(item => (
                        <option value={item.Id}> {item.Title}  </option>
                    ))
                }

            </select>
        </>
    )
});

export default Drp_Province;